export enum LiteratureName {
  HackersStartingHandbook = "hackers-starting-handbook.lit",
  CorporationManagementHandbook = "corporation-management-handbook.lit",
  HistoryOfSynthoids = "history-of-synthoids.lit",
  AGreenTomorrow = "A-Green-Tomorrow.lit",
  AlphaOmega = "alpha-omega.lit",
  SimulatedReality = "simulated-reality.lit",
  BeyondMan = "beyond-man.lit",
  BrighterThanTheSun = "brighter-than-the-sun.lit",
  DemocracyIsDead = "democracy-is-dead.lit",
  Sector12Crime = "sector-12-crime.lit",
  ManAndMachine = "man-and-machine.lit",
  SecretSocieties = "secret-societies.lit",
  TheFailedFrontier = "the-failed-frontier.lit",
  CodedIntelligence = "coded-intelligence.lit",
  SyntheticMuscles = "synthetic-muscles.lit",
  TensionsInTechRace = "tensions-in-tech-race.lit",
  CostOfImmortality = "cost-of-immortality.lit",
  TheHiddenWorld = "the-hidden-world.lit",
  TheNewGod = "the-new-god.lit",
  NewTriads = "new-triads.lit",
  TheSecretWar = "the-secret-war.lit",
  ABriefHistoryOfTranshumanism = "a-brief-history-of-transhumanism.lit",
  DarknetHandbook = "darknet-handbook.lit",
  CacheHint1 = "cache-note-1.lit",
  CacheHint2 = "cache-note-2.lit",
  ServerOfflineHint = "server-offline-problem.lit",
  DarkWebRebootHint = "darkweb-rebooted-again.lit",
  PasswordServerHint = "partial-password-jutsu.lit",
  TimingServerHint = "timing-attack.lit",
  BinaryServerHint = "raw-data.lit",
  DogNameHint = "dog-name-ideas.lit",
  FactoryDefaultHint = "factory-default.lit",
  StasisLinkHint = "stasis-link.lit",
  LabHint = "secrets-in-the-depths.lit",
}

export const DiscoverableScriptName = {
  GuessingGame: "guessing_game.wip.js",
  CloudServerUpgrades: "upgrade_cloud_server.wip.ts",
  PortSender: "port_sender.wip.js",
  PortReceiver: "port_receiver.wip.js",
  ServerFinder: "server_finder.wip.js",
  CustomLogScript: "escaping_your_chains.wip.jsx",
  CustomContentScript: "build_new_worlds.wip.jsx",
  HackController: "hack_controller.wip.js",
  HackChildScript: "hack.wip.js",
  InfiniteLoop: "infinite_loop.wip.js",
} as const;

export type DiscoverableScriptNameType = (typeof DiscoverableScriptName)[keyof typeof DiscoverableScriptName];
